import { Pipe, PipeTransform } from '@angular/core';
import { TableAction } from '../dto/data-table-structure/table-action';

@Pipe({ name: 'isActionVisible', pure: true })
export class IsActionVisiblePipe implements PipeTransform {
    transform(action: TableAction, row: any): boolean {
        if (typeof action.isHidden === 'function') {
            return !action.isHidden(row);
        }
        return !action.isHidden;
    }
}
